import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const pesquisa = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('questionario/perguntas/respostas',{
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.QUESTIONARIO.PESQUISA_RESP);
            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const atualizaPesquisa = (dados = {}) => {
    return dispatch => {
        dispatch({
            payload: dados,
            type: types.QUESTIONARIO.PESQUISA_RESP
        });
    }
}

export const novoatualiza = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('questionario/perguntas/respostas/novoatualiza',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }
            });

            dispatchresponse(dispatch, response.data,types.QUESTIONARIO.CADATUALIZARESP);
            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const zeranovoatualiza = () => {
    return dispatch => {
        dispatch({
            type: types.QUESTIONARIO.CADATUALIZAPERG,
            payload: {}
        })
    }
}